import { createContext, useState } from "react";

export const NationContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [nations, setNations] = useState([]);

    // Make the context object:
    const nationContext = {
        nations,
        setNations,
    };

    // pass the value in provider and return
    return <NationContext.Provider value={nationContext}>{children}</NationContext.Provider>;
};

export const { Consumer } = NationContext;
